export enum LoanRequestStatus {
  SUBMITTED = 1,
  PENDING_VALIDATION = 2,
  FINISHED_VALIDATION = 3,
  PENDING_LOAN_TYPE = 4,
  PENDING_BANK_ACCOUNT_VALIDATION = 5,
  FILLING_DOCUMENT = 6,
  DOCUMENT_FILLED = 7,
  PENDING_DIGITAL_SIGN = 8,
  FINISHED_DIGITAL_SIGN = 9,
  PENDING_FINAL_REVIEW = 10,
  COMPLETED = 11,
  REJECTED_BANK_ACCOUNT = 12,
  REJECTED_LOAN_REQUEST = 13,
}

export type LoanRequestStatusLabel =
  | 'Submitted'
  | 'Pending validation'
  | 'Finished validation'
  | 'Select loan type'
  | 'Pending bank account validation'
  | 'Filling document'
  | 'Document filled'
  | 'Pending digital sign'
  | 'Finished digital sign'
  | 'Pending final review'
  | 'Completed'
  | 'Rejected Bank Account'
  | 'Rejected Loan Request';

export const LOAN_STATUS_LABELS: Record<
  LoanRequestStatus,
  LoanRequestStatusLabel
> = {
  [LoanRequestStatus.SUBMITTED]: 'Submitted',
  [LoanRequestStatus.PENDING_VALIDATION]: 'Pending validation',
  [LoanRequestStatus.FINISHED_VALIDATION]: 'Finished validation',
  [LoanRequestStatus.PENDING_LOAN_TYPE]: 'Select loan type',
  [LoanRequestStatus.PENDING_BANK_ACCOUNT_VALIDATION]:
    'Pending bank account validation',
  [LoanRequestStatus.FILLING_DOCUMENT]: 'Filling document',
  [LoanRequestStatus.DOCUMENT_FILLED]: 'Document filled',
  [LoanRequestStatus.PENDING_DIGITAL_SIGN]: 'Pending digital sign',
  [LoanRequestStatus.FINISHED_DIGITAL_SIGN]: 'Finished digital sign',
  [LoanRequestStatus.PENDING_FINAL_REVIEW]: 'Pending final review',
  [LoanRequestStatus.COMPLETED]: 'Completed',
  [LoanRequestStatus.REJECTED_BANK_ACCOUNT]: 'Rejected Bank Account',
  [LoanRequestStatus.REJECTED_LOAN_REQUEST]: 'Rejected Loan Request',
};

export const LOAN_STATUS_BADGE_LABELS: Record<LoanRequestStatus, string> = {
  [LoanRequestStatus.SUBMITTED]: 'شروع درخواست',
  [LoanRequestStatus.PENDING_VALIDATION]: 'در انتظار اعتبارسنجی',
  [LoanRequestStatus.FINISHED_VALIDATION]: 'اعتبارسنجی شده',
  [LoanRequestStatus.PENDING_LOAN_TYPE]: 'انتخاب وام',
  [LoanRequestStatus.PENDING_BANK_ACCOUNT_VALIDATION]: 'تأیید حساب بانکی',
  [LoanRequestStatus.FILLING_DOCUMENT]: 'بارگذاری مدارک',
  [LoanRequestStatus.DOCUMENT_FILLED]: 'مدارک تکمیل شده',
  [LoanRequestStatus.PENDING_DIGITAL_SIGN]: 'قرارداد امضا شود',
  [LoanRequestStatus.FINISHED_DIGITAL_SIGN]: 'قرارداد امضا شد',
  [LoanRequestStatus.PENDING_FINAL_REVIEW]: 'بررسی نهایی',
  [LoanRequestStatus.COMPLETED]: 'دریافت شده',
  [LoanRequestStatus.REJECTED_BANK_ACCOUNT]: 'رد شده',
  [LoanRequestStatus.REJECTED_LOAN_REQUEST]: 'رد شده',
};

export const getLoanStatusLabel = (
  status: LoanRequestStatus,
): LoanRequestStatusLabel => {
  return LOAN_STATUS_LABELS[status];
};

export const getLoanStatusBadge = (status: LoanRequestStatus): string => {
  return LOAN_STATUS_BADGE_LABELS[status];
};

export const NOT_ALLOWED_DELETE_STATUSES = [
  LoanRequestStatus.PENDING_VALIDATION,
  LoanRequestStatus.PENDING_DIGITAL_SIGN,
  LoanRequestStatus.FINISHED_DIGITAL_SIGN,
  LoanRequestStatus.PENDING_FINAL_REVIEW,
  LoanRequestStatus.COMPLETED,
];

export const showCancelButtonByLoanStatus = (
  loanStatus: LoanRequestStatus | null,
) => {
  if (!loanStatus) return false;

  return !NOT_ALLOWED_DELETE_STATUSES.includes(loanStatus);
};

export const getLoanCardHeaderStatus = (status: LoanRequestStatus): string => {
  switch (status) {
    case LoanRequestStatus.SUBMITTED:
      return 'درخواست دریافت وام';

    case LoanRequestStatus.PENDING_VALIDATION:
      return 'درخواست دریافت اعتبارسنجی';

    case LoanRequestStatus.FINISHED_VALIDATION:
      return 'اعتبار سنجی شده';

    case LoanRequestStatus.PENDING_LOAN_TYPE:
      return 'مرحله انتخاب وام';

    default:
      return 'مشخص نشده';
  }
};
